<template>
  <div class="register">
    <v-card-text primary-title class="pb-0 pt-2 text-xs-center" row>
      <h2 class="headline">Register for Survey</h2>
    </v-card-text>

    <v-card-text class="pb-0 pt-2">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-text-field
          v-model="data.username"
          data-test="username"
          :rules="[rules.required]"
          type="text"
          label="Your name"
        ></v-text-field>

        <v-select
          v-model="data.functional_area_id"
          data-test="functional_area_id"
          :items="functionalAreaOptions"
          item-value="id"
          item-text="name"
          :rules="[rules.required]"
          label="Functional Area"
        ></v-select>

        <v-select
          v-model="data.seniority_id"
          data-test="seniority_id"
          :items="seniorityOptions"
          item-value="id"
          item-text="name"
          :rules="[rules.required]"
          label="Seniority"
        ></v-select>

        <v-text-field
          v-model="data.password"
          data-test="password"
          :append-icon="visiblePassword ? 'visibility_off' : 'visibility'"
          :rules="[rules.required, rules.min]"
          :type="visiblePassword ? 'text' : 'password'"
          label="Create your password"
          counter
          validate-on-blur
          @click:append="visiblePassword = !visiblePassword"
        ></v-text-field>

        <v-checkbox
          v-model="data.terms_accepted"
          data-test="terms_accepted"
          :rules="[rules.accepted]"
          required
        >
          <template slot="label">
              I accept&nbsp;<a @click.stop="openTermsModal" class="underlined"> terms and conditions</a>
          </template>
        </v-checkbox>
      </v-form>
    </v-card-text>

    <v-card-actions class="pb-4">
      <v-btn large color="error" @click="clear">Cancel</v-btn>

      <v-btn
        data-test="submit"
        :disabled="!valid"
        color="success"
        large
        @click="submit"
      >
        Register for survey
      </v-btn>
    </v-card-actions>

    <div class="caption">
      Your responses to this survey are anonymous.
      <br/>
      No attempt will be made to determine the identity of respondents.
    </div>

    <terms-modal :active="termsModalActive" @close="termsModalActive = false" />
  </div>
</template>

<script>
import { values } from 'lodash'
import { email } from 'vuelidate/lib/validators'
import ErrorsModal from '@/components/ErrorsModal'
import TermsModal from '../views/Register/TermsModal'
import { mapActions } from 'vuex'

export default {
  components: {
    ErrorsModal,
    TermsModal
  },

  data () {
    return {
      data: {
        username: '',
        functional_area_id: null,
        seniority_id: null,
        password: '',
        terms_accepted: false
        /* contact_email: '',
        contact_phone: '' */
      },
      valid: false,
      errors: {
        active: false,
        content: {}
      },
      termsModalActive: false,
      logo: require('@/assets/leapq-logo.jpg'),
      functionalAreaOptions: [],
      seniorityOptions: [],
      visiblePassword: false,
      rules: {
        required: value => !!value || 'Required.',
        accepted: value => !!value || 'You have to accept terms',
        min: v => v.length >= 6 || 'Min 6 characters',
        email: v => email(v) || 'Must be an email address'
      },
    }
  },

  async created () {
    this.loadingModalActive(true)

    const functionalAreaOptions = await this.$axios('functional_areas')
    this.functionalAreaOptions = functionalAreaOptions.data.data

    const seniorityOptions = await this.$axios('seniorities')
    this.seniorityOptions = seniorityOptions.data.data

    const checkUrl = `surveys/${this.$route.params.slug}/check`
    this.$axios.post(checkUrl, {})
      .catch((error) => {
        switch(error.response.status) {
          case 403:
            this.errors.active = true
            this.errors.content.error = ['This survey is already closed.']
            this.errors.canClose = false
            break
          case 404:
            this.errors.active = true
            this.errors.content.error = ['The requested survey could not be found.']
            this.errors.canClose = false
            break
          default:
            console.log(error)
            this.errors.active = true
            this.errors.content.error = ['We were unable to open the requested survey.']
            this.errors.canClose = false
            break
        }
    })
    .finally(() => {
      this.loadingModalActive(false)
    })
  },

  methods: {
    ...mapActions({
      loadingModalActive: 'root/loadingModalActive',
    }),

    async submit () {
      if (this.$refs.form.validate()) {
        const slug = this.$route.params.slug

        const success = await store.dispatch('root/register', {
          url: `surveys/${slug}/participants`,
          data: this.data,
          survey_slug: slug
        })

        if(success) {
          await store.dispatch('root/fetchUser')
          this.$router.push({ name: 'survey', params: { slug } })
        }
      }
    },

    clear () {
      this.$refs.form.reset()
    },

    openTermsModal () {
      this.termsModalActive = true
    }
  }
}
</script>

<style scoped>
  div.register {
    padding: 25px 40px;
  }

  h2.headline {
    font-size: 32px;
    font-family: 'Montserrat', sans-serif;
    font-weight: 600;
    color: #545353;
  }

  .underlined {
    text-decoration: underline;
  }

  .caption {
    padding-bottom: 10px;
    text-align: center;
  }
</style>